import MultiFloatFilter from "./MultiFloatFilter";
import MultiFloatFilterBau from "./MultiFloatFilterBau";
export const header = [
  {
    headerName: "ID",
    field: "id",
    filter: MultiFloatFilter,
    filterParams: "id",
    lockPosition: "left",
    sortable: true,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    width: 205,
    minWidth: 205,
  },
  {
    headerName: "Region",
    field: "region",
    filter: MultiFloatFilter,
    filterParams: "region",
    lockPosition: "left",
    sortable: true,
    minWidth: 130,
    //maxWidth: 120,
    suppressRowTransform: true,
  },
  {
    headerName: "Raw Provider Name",
    field: "rawProviderName",
    filter: MultiFloatFilter,
    filterParams: "rawProviderName",
    lockPosition: "left",
    cellRenderer: "activeCellRenderer",
    cellRendererParams: {
      actionType: "rawProviderName",
    },
    width: 180,
    minWidth: 180,
    suppressRowTransform: true,
    sortable: true,
  },
  {
    headerName: "Normalized Provider Name",
    field: "normalizedProviderName",
    filter: MultiFloatFilter,
    filterParams: "normalizedProviderName",
    lockPosition: "left",
    cellRenderer: "activeCellRenderer",
    cellRendererParams: {
      actionType: "normalizedProviderName",
    },
    width: 180,
    minWidth: 180,
    suppressRowTransform: true,
    sortable: true,
  },
  {
    headerName: "Comments",
    field: "comment",
    filter: MultiFloatFilter,
    filterParams: "comment",
    lockPosition: "left",
    width: 180,
    minWidth: 180,
    cellRenderer: "activeCellRenderer",
    cellRendererParams: {
      actionType: "qcComments",
    },
    sortable: true,
  },
  {
    headerName: "Email Sent",
    field: "emailSent",
    filter: MultiFloatFilter,
    filterParams: "emailSent",
    lockPosition: "left",
    width: 220,
    minWidth: 220,
    sortable: true,
  },
  {
    headerName: "Email Sent Date",
    field: "emailSentAt",
    filter: MultiFloatFilter,
    filterParams: "emailSentAt",
    lockPosition: "left",
    cellRenderer: "activeCellRenderer",
    cellRendererParams: {
      actionType: "emailSentAt",
    },
    width: 180,
    minWidth: 180,
    sortable: true,
  },
];
export const headerBau = [
  {
    headerName: "BAU ID",
    field: "bauid",
    filter: MultiFloatFilterBau,
    filterParams: "bauid",
    lockPosition: "left",
    sortable: true,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    width: 205,
    minWidth: 205,
  },
  {
    headerName: "OEM ID",
    field: "oemId",
    filter: MultiFloatFilterBau,
    filterParams: "oemId",
    lockPosition: "left",
    sortable: true,
    minWidth: 130,
    //maxWidth: 120,
    suppressRowTransform: true,
  },
  {
    headerName: "Make",
    field: "make",
    filter: MultiFloatFilterBau,
    filterParams: "make",
    lockPosition: "left",
    cellRenderer: "activeCellRenderer",
    cellRendererParams: {
      actionType: "makeBau",
    },
    width: 180,
    minWidth: 180,
    suppressRowTransform: true,
    sortable: true,
  },
  {
    headerName: "Region",
    field: "region",
    filter: MultiFloatFilterBau,
    filterParams: "region",
    lockPosition: "left",
    sortable: true,
    minWidth: 130,
    //maxWidth: 120,
    suppressRowTransform: true,
  },
  {
    headerName: "Previous Start Date",
    field: "previousStartDate",
    filter: MultiFloatFilterBau,
    filterParams: "previousStartDate",
    lockPosition: "left",
    cellRenderer: "activeCellRenderer",
    cellRendererParams: {
      actionType: "previousStartDate",
    },
    width: 180,
    minWidth: 180,
    sortable: true,
  },
  {
    headerName: "Previous End Date",
    field: "previousEndDate",
    filter: MultiFloatFilterBau,
    filterParams: "previousEndDate",
    lockPosition: "left",
    cellRenderer: "activeCellRenderer",
    cellRendererParams: {
      actionType: "previousEndDate",
    },
    width: 180,
    minWidth: 180,
    sortable: true,
  },
  {
    headerName: "Current Start Date",
    field: "currentStartDate",
    filter: MultiFloatFilterBau,
    filterParams: "currentStartDate",
    lockPosition: "left",
    cellRenderer: "activeCellRenderer",
    cellRendererParams: {
      actionType: "currentStartDate",
    },
    width: 180,
    minWidth: 180,
    sortable: true,
  },
  {
    headerName: "Current End Date",
    field: "currentEndDate",
    filter: MultiFloatFilterBau,
    filterParams: "currentEndDate",
    lockPosition: "left",
    cellRenderer: "activeCellRenderer",
    cellRendererParams: {
      actionType: "currentEndDate",
    },
    width: 180,
    minWidth: 180,
    sortable: true,
  },
  {
    headerName: "DD Log Date",
    field: "ddLogDate",
    filter: MultiFloatFilterBau,
    filterParams: "ddLogDate",
    lockPosition: "left",
    cellRenderer: "activeCellRenderer",
    cellRendererParams: {
      actionType: "ddLogDate",
    },
    width: 180,
    minWidth: 180,
    sortable: true,
  },
  {
    headerName: "DD Uploaded",
    field: "ddUploaded",
    filter: MultiFloatFilterBau,
    filterParams: "ddUploaded",
    lockPosition: "left",
    width: 180,
    minWidth: 180,
    sortable: true,
  },
  {
    headerName: "UTF8 Status",
    field: "utf8Status",
    filter: MultiFloatFilterBau,
    filterParams: "utf8Status",
    lockPosition: "left",
    width: 180,
    minWidth: 180,
    sortable: true,
  },
  {
    headerName: "Final Qc Status",
    field: "finalQcStatus",
    filter: MultiFloatFilterBau,
    filterParams: "finalQcStatus",
    lockPosition: "left",
    width: 180,
    minWidth: 180,
    sortable: true,
  },
  {
    headerName: "Upload Status Send To Servicebus",
    field: "uploadStatusSendToServicebus",
    filter: MultiFloatFilterBau,
    filterParams: "uploadStatusSendToServicebus",
    lockPosition: "left",
    width: 180,
    minWidth: 180,
    sortable: true,
  },
  {
    headerName: "File Sent For Final AutoQc",
    field: "fileSentForFinalAutoQc",
    filter: MultiFloatFilterBau,
    filterParams: "fileSentForFinalAutoQc",
    lockPosition: "left",
    width: 180,
    minWidth: 180,
    sortable: true,
  },
  {
    headerName: "Pushed To Final Table",
    field: "isPushedToFinalTable",
    filter: MultiFloatFilterBau,
    filterParams: "isPushedToFinalTable",
    lockPosition: "left",
    width: 180,
    minWidth: 180,
    sortable: true,
  },
];
